import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { APIGetDictionary } from "../apiRoutes"
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { ParamMap } from '@angular/router';


@Injectable({
  providedIn: 'root'
})
export class TranslationsService {
  lang = new Subject();
  isTranslationAvaible = new BehaviorSubject(false);
  isTranslationAvaible$ = this.isTranslationAvaible.asObservable();
  constructor(public http: HttpClient
  ) { }

  getDictionaryTranslations(language:string) {
   return this.http.get<any>(environment.domainBackEnd+APIGetDictionary+language,{
    headers: {
      "Content-Type": "application/json"
    }
   });
  }
  getLang(paramMap:Observable<ParamMap>){
    paramMap.subscribe((params:ParamMap)=>{
      let lang: string = params.get('lang') ?? location?.pathname?.split("/")[1];
      localStorage.setItem("lang", lang?? "en");
      if(!localStorage.getItem("dictionary_"+ lang.toUpperCase())){
        this.getDictionaryTranslations(lang &&lang=="pt-br"?"br":lang ?? "en").subscribe((translations: Object) => {
          localStorage.setItem("dictionary_"+ lang.toUpperCase(), JSON.stringify(translations));
        });
      }
      this.lang.next(lang);
    });
  }
}
